// @ts-check
import glyphs from "./glyphs.js";

/** @type import("../../types/icons").IconTheme */
export default {
  name: "SAP Emarsys Horizon Icons",
  glyphs,
};
